/* KEIKA TWINKLE VIVI 細胞図（Figma 最新版 525:22102 から抽出）
 * 565 x 545 の枠に、上=乾燥/乱反射・下=うるおい/均一反射 の 2 ブロックを描く。
 * 呼び出し側で位置と拡縮を指定する。 */
(function () {
  function KEIKAViviDiagram(_p) {
    var props = _p || {};
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: Object.assign({ position: "relative", width: 565, height: 545 }, props.style)
    }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 565,
      height: 279,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 315,
      top: 191,
      width: 250,
      height: 48,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      textAlign: "center",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(19,54,101)",
      whiteSpace: "pre-wrap"
    }
  }, "キメが乱れた肌は、\n光が乱反射しやすい"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 315,
      top: 153,
      width: 250,
      height: 24,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 500,
      fontSize: 15,
      textAlign: "center",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(19,54,101)"
    }
  }, "\u5149\u304C\u4E71\u53CD\u5C04"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 1,
      top: 0,
      width: 284,
      height: 230,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: -1.259,
      top: 132.364,
      width: 286.556,
      height: 98.648,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(-0.182,-0.983,0.984,-0.181,223.608,50.272)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(-0.182,-0.983,0.984,-0.181,223.197,98.643)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0.182,-0.983,0.984,0.181,0,38.693)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.341,
    height: 64.008,
    viewBox: "0 0 39.341 64.008",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,3.461,93.174)",
      transformOrigin: "0 0",
      width: 39.341,
      height: 64.008,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.542 0 L 7.799 0 C 3.492 0 0 3.505 0 7.829 L 0 56.179 C 0 60.503 3.492 64.008 7.799 64.008 L 31.542 64.008 C 35.849 64.008 39.341 60.503 39.341 56.179 L 39.341 7.829 C 39.341 3.505 35.849 0 31.542 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(-0.182,-0.983,0.984,-0.181,79.539,50.270)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(-0.182,-0.983,0.984,-0.181,79.135,98.647)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.346,
    height: 64.000,
    viewBox: "0 0 39.346 64.000",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0.182,-0.983,0.984,0.181,144.016,38.688)",
      transformOrigin: "0 0",
      width: 39.346,
      height: 64,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.546 0 L 7.8 0 C 3.492 0 0 3.505 0 7.828 L 0 56.172 C 0 60.496 3.492 64 7.8 64 L 31.546 64 C 35.854 64 39.346 60.496 39.346 56.172 L 39.346 7.828 C 39.346 3.505 35.854 0 31.546 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.341,
    height: 64.008,
    viewBox: "0 0 39.341 64.008",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,147.482,93.180)",
      transformOrigin: "0 0",
      width: 39.341,
      height: 64.008,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.542 0 L 7.799 0 C 3.492 0 0 3.505 0 7.829 L 0 56.179 C 0 60.503 3.492 64.008 7.799 64.008 L 31.542 64.008 C 35.849 64.008 39.341 60.503 39.341 56.179 L 39.341 7.829 C 39.341 3.505 35.849 0 31.542 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 12,
      width: 285,
      height: 219,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 13.373,
    height: 13.403,
    viewBox: "0 0 13.373 13.403",
    fill: "none",
    style: {
      position: "absolute",
      left: 73.428,
      top: 39.031,
      width: 13.373,
      height: 13.403,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.297 13.403 L 0 12.87 C 1.715 12.336 2.966 11.516 3.758 10.411 C 4.551 9.306 4.965 7.891 5.009 6.152 L 0.328 6.152 L 0.328 5.618 L 6.389 5.618 L 6.389 0 L 6.922 0 L 6.922 5.618 L 13.026 5.618 L 13.026 6.152 L 8.302 6.152 L 8.302 11.951 C 8.302 12.112 8.34 12.23 8.42 12.317 C 8.501 12.404 8.655 12.441 8.897 12.441 L 11.348 12.441 C 11.658 12.441 11.912 12.379 12.122 12.255 C 12.333 12.131 12.494 11.907 12.611 11.584 C 12.729 11.262 12.816 10.802 12.865 10.206 C 12.933 10.244 13.02 10.287 13.119 10.33 C 13.218 10.374 13.305 10.411 13.373 10.442 C 13.323 11.125 13.212 11.653 13.032 12.013 C 12.853 12.373 12.63 12.627 12.358 12.764 C 12.085 12.901 11.769 12.975 11.417 12.975 L 8.891 12.975 C 8.463 12.975 8.172 12.907 8.011 12.764 C 7.85 12.627 7.776 12.385 7.776 12.05 L 7.776 6.152 L 5.578 6.152 C 5.541 7.959 5.095 9.467 4.247 10.672 C 3.399 11.876 2.086 12.789 0.303 13.403 L 0.297 13.403 Z M 3.907 4.749 C 3.808 4.52 3.678 4.253 3.51 3.942 C 3.349 3.632 3.176 3.321 2.99 2.999 C 2.805 2.676 2.625 2.372 2.439 2.08 C 2.254 1.794 2.093 1.546 1.944 1.347 L 2.452 1.08 C 2.662 1.378 2.891 1.732 3.145 2.136 C 3.399 2.539 3.64 2.949 3.876 3.359 C 4.111 3.768 4.297 4.128 4.433 4.445 L 3.913 4.743 L 3.907 4.749 Z M 8.99 4.644 L 8.513 4.346 C 8.723 4.079 8.952 3.75 9.213 3.371 C 9.473 2.986 9.72 2.595 9.962 2.185 C 10.203 1.776 10.407 1.397 10.581 1.037 L 11.113 1.322 C 10.927 1.67 10.705 2.049 10.457 2.465 C 10.209 2.874 9.955 3.272 9.702 3.657 C 9.442 4.042 9.206 4.371 8.99 4.65 L 8.99 4.644 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.266,
    height: 48.445,
    viewBox: "0 0 68.266 48.445",
    fill: "none",
    style: {
      position: "absolute",
      left: 216.629,
      top: 121.542,
      width: 68.266,
      height: 48.445,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.316 48.445 C 10.656 48.445 9.034 47.936 7.641 46.955 C 5.852 45.694 4.657 43.82 4.28 41.678 L 0.125 18.062 C -0.252 15.914 0.23 13.741 1.487 11.947 C 2.744 10.153 4.614 8.954 6.75 8.576 L 54.527 0.126 C 58.96 -0.662 63.207 2.324 63.988 6.769 L 68.142 30.385 C 68.922 34.83 65.95 39.089 61.517 39.871 L 13.74 48.32 C 13.263 48.407 12.786 48.445 12.316 48.445 Z M 55.951 0.617 C 55.518 0.617 55.078 0.654 54.639 0.735 L 6.861 9.184 C 4.886 9.532 3.153 10.643 1.995 12.301 C 0.837 13.964 0.385 15.97 0.738 17.95 L 4.892 41.566 C 5.239 43.546 6.347 45.278 8 46.446 C 9.66 47.607 11.659 48.053 13.634 47.706 L 61.412 39.257 C 65.511 38.53 68.26 34.6 67.535 30.484 L 63.381 6.868 C 62.737 3.199 59.542 0.611 55.951 0.611 L 55.951 0.617 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.677,
    height: 9.703,
    viewBox: "0 0 9.677 9.703",
    fill: "none",
    style: {
      position: "absolute",
      left: 245.927,
      top: 140.913,
      width: 9.677,
      height: 9.703,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.835 9.703 C 2.532 9.703 0.483 8.046 0.074 5.693 C -0.39 3.061 1.374 0.534 3.999 0.075 C 6.624 -0.391 9.144 1.372 9.602 4.011 C 10.067 6.643 8.302 9.17 5.677 9.629 C 5.392 9.679 5.114 9.703 4.835 9.703 Z M 4.835 0.615 C 4.594 0.615 4.346 0.633 4.098 0.677 C 1.808 1.08 0.272 3.278 0.675 5.581 C 1.077 7.878 3.275 9.418 5.566 9.014 C 7.857 8.611 9.392 6.413 8.99 4.11 C 8.63 2.061 6.841 0.615 4.835 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.272,
    height: 48.444,
    viewBox: "0 0 68.272 48.444",
    fill: "none",
    style: {
      position: "absolute",
      left: 0.006,
      top: 121.542,
      width: 68.272,
      height: 48.444,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.95 48.444 C 55.48 48.444 55.003 48.4 54.527 48.32 L 6.749 39.87 C 2.316 39.088 -0.656 34.829 0.124 30.384 L 4.279 6.768 C 4.656 4.62 5.851 2.745 7.64 1.491 C 9.436 0.231 11.597 -0.253 13.739 0.126 L 61.523 8.575 C 63.665 8.954 65.534 10.152 66.785 11.946 C 68.042 13.74 68.525 15.913 68.147 18.061 L 63.993 41.677 C 63.615 43.825 62.42 45.7 60.631 46.954 C 59.238 47.935 57.616 48.444 55.957 48.444 L 55.95 48.444 Z M 12.315 0.616 C 10.779 0.616 9.281 1.088 7.993 1.994 C 6.334 3.155 5.232 4.887 4.885 6.874 L 0.731 30.49 C 0.007 34.6 2.756 38.536 6.854 39.262 L 54.632 47.711 C 58.73 48.438 62.656 45.681 63.38 41.571 L 67.534 17.955 C 67.881 15.975 67.435 13.964 66.277 12.306 C 65.12 10.642 63.386 9.537 61.411 9.19 L 13.627 0.74 C 13.188 0.666 12.748 0.622 12.315 0.622 L 12.315 0.616 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.675,
    height: 9.713,
    viewBox: "0 0 9.675 9.713",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.301,
      top: 140.91,
      width: 9.675,
      height: 9.713,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.844 9.706 C 4.559 9.706 4.274 9.681 3.996 9.632 C 2.72 9.408 1.612 8.701 0.875 7.639 C 0.138 6.577 -0.153 5.292 0.076 4.013 C 0.306 2.735 1.005 1.623 2.064 0.878 C 3.123 0.133 4.41 -0.152 5.68 0.077 C 6.955 0.301 8.063 1.009 8.8 2.07 C 9.537 3.132 9.828 4.417 9.599 5.696 C 9.376 6.975 8.67 8.086 7.611 8.831 C 6.788 9.408 5.828 9.713 4.844 9.713 L 4.844 9.706 Z M 4.825 0.618 C 3.965 0.618 3.129 0.878 2.417 1.381 C 1.494 2.027 0.875 3.001 0.683 4.113 C 0.485 5.224 0.733 6.348 1.383 7.273 C 2.027 8.198 2.999 8.819 4.107 9.011 C 5.215 9.203 6.336 8.961 7.258 8.309 C 8.181 7.664 8.8 6.689 8.992 5.578 C 9.19 4.467 8.942 3.343 8.292 2.418 C 7.642 1.493 6.676 0.872 5.568 0.68 C 5.32 0.636 5.073 0.611 4.825 0.611 L 4.825 0.618 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.473,
    height: 49.035,
    viewBox: "0 0 68.473 49.035",
    fill: "none",
    style: {
      position: "absolute",
      left: 216.529,
      top: 169.965,
      width: 68.473,
      height: 49.035,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.632 49.035 C 11.01 49.035 9.425 48.544 8.045 47.607 C 6.237 46.371 5.017 44.515 4.609 42.373 L 0.145 18.813 C -0.697 14.374 2.219 10.078 6.646 9.234 L 54.312 0.145 C 58.738 -0.699 63.023 2.225 63.865 6.664 L 68.329 30.224 C 69.171 34.663 66.255 38.959 61.828 39.803 L 14.162 48.892 C 13.654 48.991 13.14 49.035 12.632 49.035 Z M 55.835 0.623 C 55.37 0.623 54.894 0.667 54.423 0.76 L 6.757 9.849 C 2.665 10.631 -0.029 14.598 0.752 18.701 L 5.215 42.262 C 5.593 44.242 6.72 45.955 8.392 47.098 C 10.063 48.24 12.069 48.662 14.044 48.283 L 61.71 39.195 C 65.803 38.412 68.496 34.445 67.716 30.342 L 63.252 6.782 C 62.565 3.156 59.389 0.623 55.841 0.623 L 55.835 0.623 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.681,
    height: 9.710,
    viewBox: "0 0 9.681 9.710",
    fill: "none",
    style: {
      position: "absolute",
      left: 245.923,
      top: 189.629,
      width: 9.681,
      height: 9.71,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.827 9.71 C 3.868 9.71 2.926 9.424 2.115 8.865 C 1.044 8.139 0.326 7.034 0.085 5.761 C -0.411 3.135 1.317 0.59 3.936 0.087 C 5.205 -0.155 6.493 0.112 7.564 0.844 C 8.635 1.571 9.353 2.676 9.594 3.948 C 9.836 5.221 9.57 6.512 8.839 7.586 C 8.115 8.66 7.013 9.381 5.743 9.623 C 5.44 9.679 5.131 9.71 4.827 9.71 Z M 4.846 0.621 C 4.58 0.621 4.313 0.646 4.047 0.695 C 1.763 1.13 0.258 3.352 0.691 5.643 C 0.902 6.755 1.533 7.717 2.462 8.35 C 3.397 8.983 4.518 9.219 5.626 9.008 C 6.734 8.797 7.694 8.164 8.325 7.233 C 8.957 6.301 9.192 5.171 8.981 4.06 C 8.771 2.949 8.139 1.987 7.211 1.353 C 6.505 0.869 5.682 0.621 4.846 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 64.853,
    height: 40.359,
    viewBox: "0 0 64.853 40.359",
    fill: "none",
    style: {
      position: "absolute",
      left: 1.709,
      top: 174.307,
      width: 64.853,
      height: 40.359,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.687 40.359 L 8.166 40.359 C 3.665 40.359 0 36.684 0 32.171 L 0 8.189 C 0 3.675 3.665 0 8.166 0 L 56.687 0 C 61.188 0 64.853 3.675 64.853 8.189 L 64.853 32.171 C 64.853 36.684 61.188 40.359 56.687 40.359 Z M 8.166 0.615 C 4.006 0.615 0.619 4.011 0.619 8.182 L 0.619 32.165 C 0.619 36.337 4.006 39.732 8.166 39.732 L 56.687 39.732 C 60.847 39.732 64.234 36.337 64.234 32.165 L 64.234 8.182 C 64.234 4.011 60.847 0.615 56.687 0.615 L 8.166 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.683,
    height: 9.710,
    viewBox: "0 0 9.683 9.710",
    fill: "none",
    style: {
      position: "absolute",
      left: 29.297,
      top: 189.623,
      width: 9.683,
      height: 9.71,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.842 9.71 C 2.173 9.71 0 7.531 0 4.855 C 0 2.179 2.173 0 4.842 0 C 7.51 0 9.683 2.179 9.683 4.855 C 9.683 7.531 7.51 9.71 4.842 9.71 Z M 4.842 0.627 C 2.514 0.627 0.619 2.527 0.619 4.861 C 0.619 7.195 2.514 9.095 4.842 9.095 C 7.169 9.095 9.064 7.195 9.064 4.861 C 9.064 2.527 7.169 0.627 4.842 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.272,
    height: 48.445,
    viewBox: "0 0 68.272 48.445",
    fill: "none",
    style: {
      position: "absolute",
      left: 72.058,
      top: 121.542,
      width: 68.272,
      height: 48.445,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.316 48.445 C 10.656 48.445 9.034 47.936 7.641 46.955 C 5.852 45.694 4.651 43.82 4.28 41.678 L 0.125 18.062 C -0.252 15.914 0.23 13.747 1.487 11.947 C 2.744 10.153 4.614 8.954 6.75 8.576 L 54.534 0.126 C 58.967 -0.662 63.214 2.324 63.994 6.769 L 68.148 30.385 C 68.928 34.83 65.956 39.089 61.523 39.871 L 13.74 48.32 C 13.263 48.407 12.786 48.445 12.316 48.445 Z M 55.958 0.617 C 55.524 0.617 55.085 0.654 54.645 0.735 L 6.861 9.184 C 4.886 9.532 3.159 10.643 1.995 12.301 C 0.837 13.964 0.385 15.97 0.738 17.95 L 4.892 41.566 C 5.617 45.676 9.542 48.432 13.641 47.706 L 61.424 39.257 C 65.523 38.53 68.272 34.6 67.548 30.484 L 63.393 6.868 C 62.749 3.199 59.555 0.611 55.964 0.611 L 55.958 0.617 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.676,
    height: 9.709,
    viewBox: "0 0 9.676 9.709",
    fill: "none",
    style: {
      position: "absolute",
      left: 101.357,
      top: 140.908,
      width: 9.676,
      height: 9.709,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.829 9.709 C 3.844 9.709 2.885 9.405 2.061 8.828 C 1.003 8.083 0.297 6.971 0.074 5.693 C -0.149 4.414 0.136 3.129 0.873 2.067 C 1.616 1.005 2.724 0.298 3.999 0.074 C 5.275 -0.149 6.556 0.136 7.615 0.875 C 8.674 1.62 9.379 2.731 9.602 4.01 C 9.825 5.289 9.54 6.574 8.804 7.636 C 8.061 8.697 6.952 9.405 5.677 9.629 C 5.392 9.678 5.107 9.703 4.829 9.703 L 4.829 9.709 Z M 4.847 0.621 C 4.6 0.621 4.352 0.645 4.104 0.689 C 2.996 0.887 2.024 1.502 1.38 2.427 C 0.736 3.352 0.483 4.476 0.681 5.587 C 0.879 6.698 1.492 7.673 2.414 8.319 C 3.337 8.964 4.457 9.213 5.566 9.02 C 6.674 8.822 7.646 8.207 8.29 7.282 C 8.934 6.357 9.187 5.233 8.989 4.122 C 8.791 3.011 8.178 2.036 7.256 1.39 C 6.538 0.887 5.702 0.627 4.847 0.627 L 4.847 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.266,
    height: 48.445,
    viewBox: "0 0 68.266 48.445",
    fill: "none",
    style: {
      position: "absolute",
      left: 144.527,
      top: 121.542,
      width: 68.266,
      height: 48.445,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.957 48.445 C 55.486 48.445 55.009 48.401 54.533 48.32 L 6.749 39.871 C 2.316 39.089 -0.656 34.83 0.124 30.385 L 4.279 6.769 C 5.059 2.324 9.3 -0.662 13.739 0.126 L 61.516 8.576 C 63.659 8.954 65.528 10.153 66.779 11.947 C 68.03 13.741 68.519 15.914 68.141 18.062 L 63.987 41.678 C 63.609 43.826 62.414 45.701 60.625 46.955 C 59.232 47.936 57.61 48.445 55.95 48.445 L 55.957 48.445 Z M 12.321 0.617 C 8.73 0.617 5.535 3.206 4.892 6.875 L 0.737 30.491 C 0.013 34.6 2.762 38.536 6.86 39.263 L 54.644 47.712 C 56.619 48.06 58.625 47.613 60.278 46.452 C 61.937 45.291 63.039 43.553 63.386 41.572 L 67.54 17.956 C 67.887 15.976 67.441 13.964 66.284 12.307 C 65.126 10.643 63.399 9.538 61.417 9.19 L 13.64 0.741 C 13.2 0.666 12.761 0.623 12.327 0.623 L 12.321 0.617 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.675,
    height: 9.706,
    viewBox: "0 0 9.675 9.706",
    fill: "none",
    style: {
      position: "absolute",
      left: 173.828,
      top: 140.91,
      width: 9.675,
      height: 9.706,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.838 9.706 C 4.559 9.706 4.28 9.681 3.996 9.632 C 2.72 9.408 1.612 8.701 0.875 7.639 C 0.138 6.577 -0.153 5.292 0.076 4.013 C 0.299 2.735 1.005 1.623 2.064 0.878 C 3.123 0.133 4.41 -0.152 5.68 0.077 C 6.949 0.307 8.063 1.009 8.8 2.07 C 9.537 3.132 9.828 4.417 9.599 5.696 C 9.184 8.049 7.141 9.706 4.838 9.706 Z M 4.825 0.618 C 3.965 0.618 3.129 0.878 2.417 1.381 C 1.494 2.027 0.875 3.001 0.683 4.113 C 0.491 5.224 0.733 6.348 1.383 7.273 C 2.033 8.198 2.999 8.819 4.107 9.011 C 6.398 9.415 8.589 7.875 8.998 5.578 C 9.196 4.467 8.948 3.343 8.298 2.418 C 7.655 1.493 6.682 0.872 5.574 0.68 C 5.327 0.636 5.079 0.611 4.831 0.611 L 4.825 0.618 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 68.474,
    height: 49.036,
    viewBox: "0 0 68.474 49.036",
    fill: "none",
    style: {
      position: "absolute",
      left: 71.958,
      top: 169.964,
      width: 68.474,
      height: 49.036,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.632 49.036 C 11.01 49.036 9.425 48.545 8.045 47.608 C 6.237 46.372 5.017 44.516 4.609 42.374 L 0.145 18.814 C -0.697 14.375 2.219 10.079 6.646 9.235 L 54.312 0.146 C 56.448 -0.264 58.621 0.196 60.429 1.431 C 62.236 2.667 63.456 4.523 63.865 6.665 L 68.329 30.225 C 68.737 32.367 68.279 34.546 67.047 36.358 C 65.815 38.171 63.964 39.394 61.828 39.804 L 14.162 48.893 C 13.654 48.992 13.14 49.036 12.632 49.036 Z M 55.841 0.624 C 55.37 0.624 54.9 0.668 54.429 0.761 L 6.763 9.85 C 2.677 10.632 -0.022 14.599 0.758 18.702 L 5.222 42.262 C 5.599 44.243 6.726 45.956 8.398 47.099 C 10.069 48.241 12.081 48.663 14.05 48.284 L 61.716 39.196 C 63.691 38.817 65.4 37.687 66.539 36.011 C 67.679 34.335 68.1 32.323 67.722 30.343 L 63.258 6.783 C 62.88 4.802 61.754 3.089 60.082 1.946 C 58.807 1.077 57.339 0.624 55.841 0.624 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.681,
    height: 9.709,
    viewBox: "0 0 9.681 9.709",
    fill: "none",
    style: {
      position: "absolute",
      left: 101.358,
      top: 189.629,
      width: 9.681,
      height: 9.709,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.834 9.709 C 2.555 9.709 0.525 8.089 0.085 5.761 C -0.41 3.135 1.311 0.59 3.936 0.087 C 6.555 -0.416 9.093 1.322 9.595 3.948 C 9.836 5.221 9.57 6.512 8.839 7.586 C 8.115 8.66 7.013 9.38 5.744 9.622 C 5.44 9.678 5.137 9.709 4.84 9.709 L 4.834 9.709 Z M 4.846 0.621 C 4.58 0.621 4.314 0.645 4.047 0.695 C 1.763 1.13 0.258 3.352 0.692 5.643 C 1.125 7.934 3.342 9.442 5.626 9.008 C 6.734 8.797 7.694 8.163 8.325 7.232 C 8.957 6.301 9.192 5.171 8.982 4.06 C 8.771 2.949 8.14 1.986 7.211 1.353 C 6.505 0.869 5.682 0.621 4.846 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 64.853,
    height: 40.359,
    viewBox: "0 0 64.853 40.359",
    fill: "none",
    style: {
      position: "absolute",
      left: 146.236,
      top: 174.307,
      width: 64.853,
      height: 40.359,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.687 40.359 L 8.166 40.359 C 3.665 40.359 0 36.684 0 32.171 L 0 8.189 C 0 3.675 3.665 0 8.166 0 L 56.687 0 C 61.188 0 64.853 3.675 64.853 8.189 L 64.853 32.171 C 64.853 36.684 61.188 40.359 56.687 40.359 Z M 8.172 0.615 C 4.012 0.615 0.625 4.011 0.625 8.182 L 0.625 32.165 C 0.625 36.337 4.012 39.732 8.172 39.732 L 56.693 39.732 C 60.853 39.732 64.24 36.337 64.24 32.165 L 64.24 8.182 C 64.24 4.011 60.853 0.615 56.693 0.615 L 8.172 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.683,
    height: 9.710,
    viewBox: "0 0 9.683 9.710",
    fill: "none",
    style: {
      position: "absolute",
      left: 173.824,
      top: 189.623,
      width: 9.683,
      height: 9.71,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.842 9.71 C 2.173 9.71 0 7.531 0 4.855 C 0 2.179 2.173 0 4.842 0 C 7.51 0 9.683 2.179 9.683 4.855 C 9.683 7.531 7.51 9.71 4.842 9.71 Z M 4.842 0.627 C 2.514 0.627 0.619 2.527 0.619 4.861 C 0.619 7.195 2.514 9.095 4.842 9.095 C 7.169 9.095 9.064 7.195 9.064 4.861 C 9.064 2.527 7.169 0.627 4.842 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.330,
    height: 7.170,
    viewBox: "0 0 9.330 7.170",
    fill: "none",
    style: {
      position: "absolute",
      left: 182.542,
      top: 75.107,
      width: 9.33,
      height: 7.17,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.089 0 L 0 2.21 L 0.074 2.446 L 6.556 1.012 L 9.095 7.17 L 9.33 7.096 L 7.089 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 91.011,
    height: 74.306,
    viewBox: "0 0 91.011 74.306",
    fill: "none",
    style: {
      position: "absolute",
      left: 98.385,
      top: 75.076,
      width: 91.011,
      height: 74.306,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.05 74.306 L 0 0.255 L 0.427 0 L 44.069 73.362 L 90.59 0.819 L 91.011 1.086 L 44.05 74.306 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 45.765,
    height: 45.891,
    viewBox: "0 0 45.765 45.891",
    fill: "none",
    style: {
      position: "absolute",
      left: 120.134,
      top: 111.474,
      width: 45.765,
      height: 45.891,
      opacity: 0.5,
      color: "rgb(194,189,187)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.883 45.891 C 35.52 45.891 45.765 35.618 45.765 22.945 C 45.765 10.273 35.52 0 22.883 0 C 10.245 0 0 10.273 0 22.945 C 0 35.618 10.245 45.891 22.883 45.891 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("div", { style: { position: "absolute", left: 0, top: 248, width: 283, height: 31, display: "flex", justifyContent: "center", gap: 8 } }, React.createElement("span", { style: { display: "inline-block", padding: "0 14px", backgroundColor: "rgb(218,224,232)", fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "31px", letterSpacing: "0.040em", whiteSpace: "nowrap", color: "rgb(19,54,101)" } }, "乾燥"), React.createElement("span", { style: { display: "inline-block", padding: "0 14px", backgroundColor: "rgb(218,224,232)", fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "31px", letterSpacing: "0.040em", whiteSpace: "nowrap", color: "rgb(19,54,101)" } }, "不整理な状態"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 270,
      width: 565,
      height: 275,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      width: 283,
      height: 230,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0.31,
      top: 141.34,
      width: 282.377,
      height: 88.077,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,72.662,39.693)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,145.324,39.693)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,217.979,39.686)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,0,88.077)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,72.662,88.071)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,145.317,88.077)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,217.973,88.071)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 39.686,
    height: 64.400,
    viewBox: "0 0 39.686 64.400",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      transform: "matrix(0,-1,1,0,0.006,39.693)",
      transformOrigin: "0 0",
      width: 39.686,
      height: 64.4,
      opacity: 0.7,
      color: "rgb(239,231,230)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.818 0 L 7.868 0 C 3.523 0 0 3.527 0 7.877 L 0 56.523 C 0 60.873 3.523 64.4 7.868 64.4 L 31.818 64.4 C 36.163 64.4 39.686 60.873 39.686 56.523 L 39.686 7.877 C 39.686 3.527 36.163 0 31.818 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      top: 13,
      width: 283,
      height: 217,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: 8.429,
    height: 7.405,
    viewBox: "0 0 8.429 7.405",
    fill: "none",
    style: {
      position: "absolute",
      left: 113.81,
      top: 62.573,
      width: 8.429,
      height: 7.405,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.374 0 L 0 1.019 L 0.037 1.261 L 6.685 0.913 L 8.187 7.405 L 8.429 7.374 L 7.374 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 34.264,
    height: 34.294,
    viewBox: "0 0 34.264 34.294",
    fill: "none",
    style: {
      position: "absolute",
      left: 196.72,
      top: 99.439,
      width: 34.264,
      height: 34.294,
      opacity: 0.5,
      color: "rgb(255,240,210)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.132 34.294 C 26.594 34.294 34.264 26.617 34.264 17.147 C 34.264 7.677 26.594 0 17.132 0 C 7.67 0 0 7.677 0 17.147 C 0 26.617 7.67 34.294 17.132 34.294 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 97.087,
    height: 56.982,
    viewBox: "0 0 97.087 56.982",
    fill: "none",
    style: {
      position: "absolute",
      left: 23.966,
      top: 62.946,
      width: 97.087,
      height: 56.982,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.816 56.982 L 44.587 56.715 L 0 3.411 L 0.478 3.013 L 44.835 56.044 L 96.634 0 L 97.087 0.422 L 44.816 56.982 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 8.429,
    height: 7.405,
    viewBox: "0 0 8.429 7.405",
    fill: "none",
    style: {
      position: "absolute",
      left: 258.345,
      top: 62.573,
      width: 8.429,
      height: 7.405,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.374 0 L 0 1.019 L 0.037 1.261 L 6.685 0.913 L 8.187 7.405 L 8.429 7.374 L 7.374 0 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 97.087,
    height: 56.982,
    viewBox: "0 0 97.087 56.982",
    fill: "none",
    style: {
      position: "absolute",
      left: 168.501,
      top: 62.946,
      width: 97.087,
      height: 56.982,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.81 56.982 L 44.587 56.715 L 0 3.411 L 0.478 3.013 L 44.835 56.044 L 96.634 0 L 97.087 0.422 L 44.81 56.982 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 13.408,
    height: 13.419,
    viewBox: "0 0 13.408 13.419",
    fill: "none",
    style: {
      position: "absolute",
      left: 0.869,
      top: 38.549,
      width: 13.408,
      height: 13.419,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.298 13.413 L 0 12.879 C 1.719 12.344 2.973 11.524 3.768 10.419 C 4.562 9.313 4.978 7.896 5.022 6.157 L 0.329 6.157 L 0.329 5.622 L 6.406 5.622 L 6.406 0 L 6.94 0 L 6.94 5.622 L 13.06 5.622 L 13.06 6.157 L 8.324 6.157 L 8.324 11.959 C 8.324 12.121 8.361 12.239 8.442 12.326 C 8.523 12.413 8.678 12.45 8.92 12.45 L 11.378 12.45 C 11.688 12.45 11.943 12.388 12.154 12.264 C 12.365 12.139 12.526 11.916 12.644 11.593 C 12.762 11.27 12.849 10.81 12.899 10.214 C 12.967 10.251 13.054 10.294 13.153 10.344 C 13.252 10.387 13.339 10.425 13.408 10.456 C 13.358 11.139 13.246 11.667 13.066 12.028 C 12.886 12.388 12.663 12.643 12.39 12.779 C 12.117 12.916 11.8 12.991 11.446 12.991 L 8.914 12.991 C 8.485 12.991 8.194 12.922 8.032 12.779 C 7.871 12.643 7.796 12.4 7.796 12.065 L 7.796 6.163 L 5.593 6.163 C 5.555 7.971 5.109 9.48 4.258 10.686 C 3.408 11.891 2.092 12.804 0.304 13.419 L 0.298 13.413 Z M 3.917 4.753 C 3.817 4.523 3.687 4.256 3.519 3.945 C 3.358 3.634 3.184 3.324 2.998 3.001 C 2.812 2.678 2.632 2.373 2.446 2.081 C 2.259 1.795 2.098 1.547 1.949 1.348 L 2.458 1.081 C 2.669 1.379 2.899 1.733 3.153 2.137 C 3.408 2.547 3.65 2.951 3.886 3.361 C 4.122 3.771 4.308 4.131 4.444 4.448 L 3.923 4.746 L 3.917 4.753 Z M 9.013 4.647 L 8.535 4.349 C 8.746 4.082 8.976 3.752 9.236 3.373 C 9.497 2.988 9.745 2.597 9.987 2.187 C 10.23 1.777 10.434 1.398 10.608 1.038 L 11.142 1.323 C 10.956 1.671 10.732 2.05 10.484 2.466 C 10.236 2.876 9.981 3.274 9.727 3.659 C 9.466 4.044 9.23 4.374 9.013 4.653 L 9.013 4.647 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 34.264,
    height: 34.294,
    viewBox: "0 0 34.264 34.294",
    fill: "none",
    style: {
      position: "absolute",
      left: 52.228,
      top: 99.439,
      width: 34.264,
      height: 34.294,
      opacity: 0.5,
      color: "rgb(255,240,210)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.132 34.294 C 26.594 34.294 34.264 26.617 34.264 17.147 C 34.264 7.677 26.594 0 17.132 0 C 7.67 0 0 7.677 0 17.147 C 0 26.617 7.67 34.294 17.132 34.294 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 72.662,
      top: 127.855,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.668 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.716 61.346 40.388 56.833 40.388 Z M 8.187 0.615 C 4.016 0.615 0.621 4.013 0.621 8.188 L 0.621 32.187 C 0.621 36.362 4.016 39.761 8.187 39.761 L 56.833 39.761 C 61.005 39.761 64.4 36.362 64.4 32.187 L 64.4 8.188 C 64.4 4.013 61.005 0.615 56.833 0.615 L 8.187 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 100.315,
      top: 143.188,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.627 C 2.52 0.627 0.621 2.529 0.621 4.864 C 0.621 7.2 2.52 9.101 4.854 9.101 C 7.188 9.101 9.087 7.2 9.087 4.864 C 9.087 2.529 7.188 0.627 4.854 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 145.317,
      top: 127.855,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.675 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.716 61.346 40.388 56.833 40.388 Z M 8.194 0.615 C 4.022 0.615 0.627 4.013 0.627 8.188 L 0.627 32.187 C 0.627 36.362 4.022 39.761 8.194 39.761 L 56.84 39.761 C 61.011 39.761 64.406 36.362 64.406 32.187 L 64.406 8.188 C 64.406 4.013 61.011 0.615 56.84 0.615 L 8.194 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 172.977,
      top: 143.188,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.627 C 2.52 0.627 0.621 2.529 0.621 4.864 C 0.621 7.2 2.52 9.101 4.854 9.101 C 7.188 9.101 9.087 7.2 9.087 4.864 C 9.087 2.529 7.188 0.627 4.854 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 217.979,
      top: 127.855,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.675 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.716 61.346 40.388 56.833 40.388 Z M 8.187 0.615 C 4.016 0.615 0.621 4.013 0.621 8.188 L 0.621 32.187 C 0.621 36.362 4.016 39.761 8.187 39.761 L 56.833 39.761 C 61.005 39.761 64.4 36.362 64.4 32.187 L 64.4 8.188 C 64.4 4.013 61.005 0.615 56.833 0.615 L 8.187 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 245.632,
      top: 143.188,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.627 C 2.52 0.627 0.621 2.529 0.621 4.864 C 0.621 7.2 2.52 9.101 4.854 9.101 C 7.188 9.101 9.087 7.2 9.087 4.864 C 9.087 2.529 7.188 0.627 4.854 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.394,
    viewBox: "0 0 65.021 40.394",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 176.606,
      width: 65.021,
      height: 40.394,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.394 L 8.194 40.394 C 3.675 40.394 0 36.716 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.71 61.346 40.388 56.833 40.388 L 56.833 40.394 Z M 8.194 0.621 C 4.022 0.621 0.627 4.02 0.627 8.194 L 0.627 32.194 C 0.627 36.369 4.022 39.767 8.194 39.767 L 56.84 39.767 C 61.011 39.767 64.406 36.369 64.406 32.194 L 64.406 8.194 C 64.406 4.02 61.011 0.621 56.84 0.621 L 8.194 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 27.659,
      top: 191.945,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.621 C 2.52 0.621 0.621 2.522 0.621 4.858 C 0.621 7.194 2.52 9.095 4.854 9.095 C 7.188 9.095 9.087 7.194 9.087 4.858 C 9.087 2.522 7.188 0.621 4.854 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 72.662,
      top: 176.612,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.668 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.71 61.346 40.388 56.833 40.388 Z M 8.187 0.615 C 4.016 0.615 0.621 4.013 0.621 8.188 L 0.621 32.187 C 0.621 36.362 4.016 39.761 8.187 39.761 L 56.833 39.761 C 61.005 39.761 64.4 36.362 64.4 32.187 L 64.4 8.188 C 64.4 4.013 61.005 0.615 56.833 0.615 L 8.187 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 100.315,
      top: 191.945,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.621 C 2.52 0.621 0.621 2.522 0.621 4.858 C 0.621 7.194 2.52 9.095 4.854 9.095 C 7.188 9.095 9.087 7.194 9.087 4.858 C 9.087 2.522 7.188 0.621 4.854 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 145.317,
      top: 176.612,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.675 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.71 61.346 40.388 56.833 40.388 Z M 8.194 0.615 C 4.022 0.615 0.627 4.013 0.627 8.188 L 0.627 32.187 C 0.627 36.362 4.022 39.761 8.194 39.761 L 56.84 39.761 C 61.011 39.761 64.406 36.362 64.406 32.187 L 64.406 8.188 C 64.406 4.013 61.011 0.615 56.84 0.615 L 8.194 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 172.977,
      top: 191.945,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.621 C 2.52 0.621 0.621 2.522 0.621 4.858 C 0.621 7.194 2.52 9.095 4.854 9.095 C 7.188 9.095 9.087 7.194 9.087 4.858 C 9.087 2.522 7.188 0.621 4.854 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 217.979,
      top: 176.612,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.675 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.71 61.346 40.388 56.833 40.388 Z M 8.187 0.615 C 4.016 0.615 0.621 4.013 0.621 8.188 L 0.621 32.187 C 0.621 36.362 4.016 39.761 8.187 39.761 L 56.833 39.761 C 61.005 39.761 64.4 36.362 64.4 32.187 L 64.4 8.188 C 64.4 4.013 61.005 0.615 56.833 0.615 L 8.187 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 245.632,
      top: 191.945,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.621 C 2.52 0.621 0.621 2.522 0.621 4.858 C 0.621 7.194 2.52 9.095 4.854 9.095 C 7.188 9.095 9.087 7.194 9.087 4.858 C 9.087 2.522 7.188 0.621 4.854 0.621 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 65.021,
    height: 40.388,
    viewBox: "0 0 65.021 40.388",
    fill: "none",
    style: {
      position: "absolute",
      left: 0,
      top: 127.855,
      width: 65.021,
      height: 40.388,
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.833 40.388 L 8.187 40.388 C 3.668 40.388 0 36.71 0 32.194 L 0 8.194 C 0 3.678 3.675 0 8.187 0 L 56.833 0 C 61.346 0 65.021 3.678 65.021 8.194 L 65.021 32.194 C 65.021 36.716 61.346 40.388 56.833 40.388 Z M 8.187 0.615 C 4.016 0.615 0.621 4.013 0.621 8.188 L 0.621 32.187 C 0.621 36.362 4.016 39.761 8.187 39.761 L 56.833 39.761 C 61.005 39.761 64.4 36.362 64.4 32.187 L 64.4 8.188 C 64.4 4.013 61.005 0.615 56.833 0.615 L 8.187 0.615 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("svg", {
    width: 9.708,
    height: 9.717,
    viewBox: "0 0 9.708 9.717",
    fill: "none",
    style: {
      position: "absolute",
      left: 27.659,
      top: 143.188,
      width: 9.708,
      height: 9.717,
      display: "none",
      color: "rgb(19,54,101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.854 9.717 C 2.179 9.717 0 7.536 0 4.858 C 0 2.181 2.179 0 4.854 0 C 7.529 0 9.708 2.181 9.708 4.858 C 9.708 7.536 7.529 9.717 4.854 9.717 Z M 4.854 0.627 C 2.52 0.627 0.621 2.529 0.621 4.864 C 0.621 7.2 2.52 9.101 4.854 9.101 C 7.188 9.101 9.087 7.2 9.087 4.864 C 9.087 2.529 7.188 0.627 4.854 0.627 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 315,
      top: 167,
      width: 250,
      height: 48,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 400,
      fontSize: 15,
      textAlign: "center",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(19,54,101)",
      whiteSpace: "pre-wrap"
    }
  }, "キメの整った肌は、\n光を均一に反射しやすい"), /*#__PURE__*/React.createElement("span", {
    style: {
      position: "absolute",
      left: 315,
      top: 129,
      width: 250,
      height: 24,
      fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
      fontWeight: 500,
      fontSize: 15,
      textAlign: "center",
      lineHeight: "24px",
      letterSpacing: "0.080em",
      color: "rgb(19,54,101)"
    }
  }, "\u5149\u3092\u5747\u4E00\u306B\u53CD\u5C04"), /*#__PURE__*/React.createElement("div", { style: { position: "absolute", left: 0, top: 244, width: 283, height: 31, display: "flex", justifyContent: "center", gap: 8 } }, React.createElement("span", { style: { display: "inline-block", padding: "0 14px", backgroundColor: "rgb(218,224,232)", fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "31px", letterSpacing: "0.040em", whiteSpace: "nowrap", color: "rgb(19,54,101)" } }, "うるおい"), React.createElement("span", { style: { display: "inline-block", padding: "0 14px", backgroundColor: "rgb(218,224,232)", fontFamily: "\"Zen Kaku Gothic New\", -apple-system, BlinkMacSystemFont, sans-serif", fontWeight: 500, fontSize: 12, lineHeight: "31px", letterSpacing: "0.040em", whiteSpace: "nowrap", color: "rgb(19,54,101)" } }, "整列した状態"))));
  }
  window.KEIKAViviDiagram = KEIKAViviDiagram;
})();
